import { css } from 'styled-components';
export const MAX_WIDTH_AI_WELCOME_MESSAGE = 400;
const MAX_WIDTH_GENERAL_WELCOME_MESSAGE = 312;
const MAX_WIDTH_AI_WELCOME_MESSAGE_MOBILE = 344;
const WELCOME_MESSAGE_HEIGHT = 72;
export const getMaxWelcomeMessageContainerWidth = (isAIChatBot, isMobile) => {
  if (isAIChatBot) {
    if (isMobile) {
      return MAX_WIDTH_AI_WELCOME_MESSAGE_MOBILE;
    }
    return MAX_WIDTH_AI_WELCOME_MESSAGE;
  }
  return MAX_WIDTH_GENERAL_WELCOME_MESSAGE;
};
const getWelcomeMessageMinHeight = (isAIChatBot, defaultHeight) => isAIChatBot ? Math.min(defaultHeight, WELCOME_MESSAGE_HEIGHT) : WELCOME_MESSAGE_HEIGHT;
export const getCurrentWelcomeMessageDimensionStyles = ({
  showInputField,
  defaultWidth,
  defaultHeight,
  hasTextContent,
  isAIChatBot,
  mobile: isMobile
}) => {
  const minHeight = getWelcomeMessageMinHeight(isAIChatBot, defaultHeight);
  if (!isAIChatBot) {
    return css(["min-height:", "px;"], minHeight);
  }
  if (showInputField) {
    const maxWidth = getMaxWelcomeMessageContainerWidth(isAIChatBot, isMobile);
    if (hasTextContent) {
      return css(["width:", "px;min-height:", "px;height:auto;"], maxWidth, minHeight);
    }
    return css(["width:", "px;height:", "px;"], maxWidth, minHeight);
  }
  return css(["width:", "px;height:", "px;"], defaultWidth, defaultHeight);
};